import InviteAdminModal from './InviteAdmin.modal';

export default InviteAdminModal;
